import { profileRoutes } from "@/router/profile";
import { documentsRoutes } from "@/router/documents";

export const zavtraRouter = [
    {
        path: "/",
        name: "Home",
        component: () => import(/* webpackChunkName: "H" */ "../pages/Home"),
    },
    {
        path: "/p/:slug/:offer?",
        name: "Product",
        component: () => import(/* webpackChunkName: "P" */ "../pages/Product"),
        props: (route) => ({
            slug: route.params.slug,
            offer: route.params.offer,
        }),
    },
    {
        path: "/p-garantiya",
        name: "Guarantee",
        component: () => import(/* webpackChunkName: "G" */ "../pages/Guarantee"),
    },
    {
        path: "/p-dostavka-i-oplata",
        name: "Payment",
        component: () => import(/* webpackChunkName: "Pay" */ "../pages/Payment"),
    },
    {
        path: "/p-o-magazine",
        name: "Store",
        component: () => import(/* webpackChunkName: "St" */ "../pages/Store"),
    },
    {
        path: "/p-optovaya-prodazha",
        name: "Wholesale",
        component: () => import(/* webpackChunkName: "WH" */ "../pages/Wholesale"),
    },
    {
        path: "/p-korporativnyy-zakaz",
        name: "Corporate",
        component: () => import(/* webpackChunkName: "CE" */ "../pages/Corporate"),
    },
    ...profileRoutes,
    ...documentsRoutes,
];
